import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useSmartNavigate from 'hooks/useSmartNavigate';
import useCustomer from 'hooks/useCustomer';
import { setSigninModalIsOpen } from 'store/slices/layoutSlice';
import Icon from 'components/Icon';

const getNavItems = (t) => [
	{ path: '/account', label: t('header.account'), icon: 'icon-profile', iconActive: 'icon-profile-active', auth: true },
	{ path: '/cart', label: t('header.cart'), icon: 'icon-cart', iconActive: 'icon-cart-red', auth: false },
	{ path: '/account/history', label: t('header.orders'), icon: 'icon-clock', iconActive: 'icon-clock-account-active', auth: true },
	{ path: '/account/wishlist', label: t('header.favorites'), icon: 'icon-wishlist', iconActive: 'icon-wishlist-active', auth: true },
];

const MobileBottomNav = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { navigate } = useSmartNavigate();
	const { customer } = useCustomer();
	const location = useLocation();
	const cartProducts = useSelector(state => state.cart.cartProducts);
	const cartCount = cartProducts.data?.count ?? 0;
	const navItems = useMemo(() => getNavItems(t), [t]);

	const handleClick = (item, e) => {
		e.preventDefault();
		if (item.auth && !customer.token) {
			dispatch(setSigninModalIsOpen(true));
			return;
		}
		navigate(item.path);
	};

	return (
		<nav className="mobile-bottom-nav" aria-label={t('common.bottomNav')}>
			{navItems.map((item) => {
				const isActive =
					item.path === '/cart'
						? location.pathname === '/cart'
						: location.pathname === item.path || location.pathname.startsWith(item.path + '/');
				const isCart = item.path === '/cart';
				const showActiveIcon = isCart ? cartCount > 0 : isActive;

				return (
					<a
						key={item.path}
						href={item.path}
						className={`mobile-bottom-nav__item ${isActive ? 'mobile-bottom-nav__item--active' : ''}`}
						onClick={(e) => handleClick(item, e)}
					>
						<span className="mobile-bottom-nav__icon-wrap">
							<Icon
								name={showActiveIcon ? item.iconActive : item.icon}
								width={24}
								height={24}
								className="mobile-bottom-nav__icon"
							/>
							{isCart && cartCount > 0 && (
								<span className="mobile-bottom-nav__badge">
									{cartCount > 99 ? '99+' : cartCount}
								</span>
							)}
						</span>
						<span className="mobile-bottom-nav__label">{item.label}</span>
					</a>
				);
			})}
		</nav>
	);
};

export default MobileBottomNav;
